// REACT, ROUTER & REDUX
import React from "react";

// IMGs & SVGs
import archiveHeaderFigure from "../img/header-archive.svg";

/*
ARCHIVE PAGE COMPONENT INFORMATION
  Archived news
*/

export default function ArchivePage() {
  // ::::: JSX :::::
  return (
    <div className="archive">
      <header>
        <figure>
          <img src={archiveHeaderFigure} alt="news-header-figure" />
        </figure>
        <h1 className="calculator-page__heading">Archive</h1>
      </header>
      <section>
        <article>
          <h3>Let's import our exports!</h3>
          <p>
            We have added two new features in the Calculator Page, Import and
            Export!
          </p>
          <p>
            The export button exports all your calculators and receipts to a
            special file (json file). Which you can later use to either share it
            with someone or keep it for yourself as a backup. Neat huh?
          </p>
          <time>2022-11-13</time>
        </article>
        <article>
          <h3>Friction added to Catalogue!</h3>
          <p>
            Many values of friction coefficient between different material added
            in the Catalogue Page. More values will be added into the table in
            the future. Go check them out!
          </p>
          <time>2022-08-27</time>
        </article>
      </section>
    </div>
  );
}
